import { isNumber } from 'utils/validation';
import {
  AutomationActionType,
  RequirementConditionOperator,
  RequirementConditionType
} from 'generated-graphql/types';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

export const validateAnalysisAutomationTask = (
  automationTask: AutomationFormItem,
  campaignIdCanBeEmpty: boolean
) => {
  const isConditionsValid = automationTask.requirementConditions.every(
    (condition) => {
      if (condition.type === RequirementConditionType.CandidateScoreCondition) {
        if (!condition.operator || !isNumber(condition.scoreScaled)) {
          return false;
        }

        // For Between operator, validate that max >= min
        if (condition.operator === RequirementConditionOperator.Between) {
          const { scoreScaled, scoreScaledMax } = condition;
          if (
            !isNumber(scoreScaledMax) ||
            (typeof scoreScaledMax === 'number' &&
              typeof scoreScaled === 'number' &&
              scoreScaledMax < scoreScaled)
          ) {
            return false;
          }
        }
      }

      if (
        condition.type ===
          RequirementConditionType.CandidateRequirementsMetCondition &&
        !condition.operator
      ) {
        return false;
      }

      if (
        condition.type === RequirementConditionType.CandidateStatusCondition &&
        !condition.candidateStatus
      ) {
        return false;
      }

      return true;
    },
    []
  );

  const isActionValid = (() => {
    const {
      type,
      campaignId,
      candidateStatus,
      atsInterviewStageId,
      atsRejectedReasonId
    } = automationTask.action;

    if (
      type === AutomationActionType.UpdateCandidateStatus &&
      !candidateStatus
    ) {
      return false;
    }

    if (
      type === AutomationActionType.SendCampaign &&
      !campaignId &&
      !campaignIdCanBeEmpty
    ) {
      return false;
    }

    if (type === AutomationActionType.UpdateAts) {
      if (!atsInterviewStageId && !atsRejectedReasonId) {
        return false;
      }
    }

    return true;
  })();

  return isConditionsValid && isActionValid;
};
